export class MonthPelletizingProductInfo {
    constructor({
          id= null, 
          month= ``,
          locName= ``,  
          materialName= ``,
          wetWeight= ``,
          dryWeight= ``,
          moisture= ``,
          productYield= ``,
          CrYield= ``,
          mineralConsumeRate= ``,
          ballConsumeRate= ``,
          earthConsumeRate= ``,
          coalConsumeRate= ``,
          stoneConsumeRate= ``,
          mud= ``,
          dust= ``,
          unqualifiedBall= ``,
          unqualifiedRawBall1= ``,
          unqualifiedRawBall2= ``,
      } = {}) {
      this.id = id;
      this.month = month;
      this.locName = locName; 
      this.materialName = materialName;    
      this.wetWeight = wetWeight;
      this.dryWeight = dryWeight;
      this.moisture = moisture;
      this.productYield = productYield;
      this.CrYield = CrYield;
      this.mineralConsumeRate = mineralConsumeRate;
      this.ballConsumeRate = ballConsumeRate;
      this.earthConsumeRate = earthConsumeRate;
      this.coalConsumeRate = coalConsumeRate;
      this.stoneConsumeRate = stoneConsumeRate;
      this.mud = mud;
      this.dust = dust;
      this.unqualifiedBall = unqualifiedBall;
      this.unqualifiedRawBall1 = unqualifiedRawBall1;
      this.unqualifiedRawBall2 = unqualifiedRawBall2;
    }
  }
  export function gridFields() {
    return Object.freeze([         
        {
          key: 'locName',
          label: 'lbl.basic.locName',
          sortable: true,
          form: {
            type: 'input'
          }
        }, 
        {
          key: 'month',
          label: 'lbl.basic.month',
          sortable: true,
          form: {
            type: 'month'
          }
        },                                
        {
          key: 'materialName',
          label: 'lbl.prd.execution.productionName',
          sortable: false,
          form: {
            type: 'input'
          }
        },               
        {
          key: 'wetWeight',
          label: 'lbl.prd.execution.wetWeight',
          sortable: false,
          form: {
            type: 'input'
          }
        },
        {
          key: 'dryWeight',
          label: 'lbl.prd.execution.dryWeight',
          sortable: false,
          form: {
            type: 'input'
          }
        },
        {
          key: 'moisture',
          label: 'lbl.prd.execution.materialMoisture',
          sortable: false,
          form: {
            type: 'input'
          }
        },
        {
          key: 'productYield',
          label: 'lbl.prd.execution.productYield',
          sortable: false,
          form: {
            type: 'input'
          }
        },
        {
          key: 'CrYield',
          label: 'lbl.prd.execution.CrYield',
          sortable: false,
          form: {
            type: 'input'
          }
        },
        // {
        //   key: 'mineralConsumeRate',
        //   label: 'lbl.prd.execution.mineralConsumeRate',
        //   sortable: false,
        //   form: {
        //     type: 'input'
        //   }
        // },
        // {
        //   key: 'ballConsumeRate',
        //   label: 'lbl.prd.execution.ballConsumeRate',
        //   sortable: false,
        //   form: {
        //     type: 'input'
        //   }
        // },
        // {
        //   key: 'earthConsumeRate',
        //   label: 'lbl.prd.execution.earthConsumeRate',
        //   sortable: false,
        //   form: {
        //     type: 'input'
        //   }
        // },
        // {
        //   key: 'coalConsumeRate',
        //   label: 'lbl.prd.execution.coalConsumeRate',
        //   sortable: false,
        //   form: {
        //     type: 'input'
        //   }
        // },
        // {
        //   key: 'stoneConsumeRate',
        //   label: 'lbl.prd.execution.stoneConsumeRate',
        //   sortable: false,
        //   form: {
        //     type: 'input'
        //   }
        // }
    ]);
  }
  export const fields = Object.freeze(Object.keys(new MonthPelletizingProductInfo()).map(i => 'entity.' + i));
  export const filterFields = [  
    'filter.plantFilter',   
    'filter.startMonthFilter',
    'filter.endMonthFilter',      
  ];
  export const filter = {  
    'plantFilter': "",   
    'startMonthFilter': "",
    'endMonthFilter': "",
  };